import React, { Component } from 'react';

import _ from 'lodash';

import "./section.css";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Nav, Button } from 'react-bootstrap';
import actions from './../../store/Actions/index.js';
import * as FileSaver from 'file-saver'
import { Modal } from 'react-bootstrap';
import AddSectionCost from './../AddSectionCost/addSectionCost.jsx';
import ChangeName from './../ChangeName/changeName.jsx';

class Section extends Component{
    state={
        sections:[],
        isAdminUser:false,
        addCost:false,
        sectionId:"",
        showChangeName:false
    };
    componentDidMount = () => {
        let sections = _.filter(this.props.detail.sections,{chapterId:this.props.chapterId});
        console.log("sections",sections);
        sections = _.sortBy(sections,['sequence']);
        console.log("sections",sections);
        this.setState({sections:sections});
        console.log("section",this.state.sections);
        if(localStorage.getItem("userType") === "superAdmin"){
            this.setState({isAdminUser:true});
        }
    }
    onClick = async(sectionId) => {
        this.props.history.push({
            pathname:"/viewsection"
        },{
            state:{
                sectionId:sectionId,
                reportId:this.props.reportId,
                chapterId:this.props.chapterId,
                chapterName:this.props.chapterName,
                sectionName:_.find(this.props.detail.sections,{_id:sectionId}).sectionName,
                reportName:this.props.reportName
            }
        });
    }
    onXMLDownload=async(sectionId) => {
        await this.props.XMLDownload({sectionId:sectionId});
        const data = new Blob([this.props.section.list.fileData], {type: "xml"});
        FileSaver.saveAs(data, sectionId + ".xml");
    }
    onAddCost=async(sectionId,sectionName) => {
        this.setState({addCost:true});
        this.setState({sectionId:sectionId});
        this.setState({sectionName:sectionName});
    }
    onHide=async() => {
        this.setState({addCost:false});
    }
    
    onSectionDelete=async(reportId,sectionId) => {
        if(window.confirm('Delete the item?')){
          await this.props.onSectionDelete({sectionId:sectionId,reportId:reportId});
          window.location.reload(true);  
        }
    }

    onSectionNameChange=async(reportId,sectionId) => {
        this.setState({showChangeName:true});
        this.setState({sectionId:sectionId});
    }

    onSectionNameClose = async() => {
        this.setState({showChangeName:false});
    }


    render(){
        return(
            <div className="col-md-12 sectionname">
                {this.state && this.state.sections && this.state.sections.map((section, index) => (
                        <div key={section._id}>
                            <div className="row">
                                <div className="col-md-6">
                                    <Nav.Link>
                                        <span>
                                            {this.props.chapterNumber}
                                        </span>
                                        <span>
                                            .{index+1}-
                                        </span>    
                                        <span onClick={this.onClick.bind(this,section._id,section.sectionName)}>
                                            {section.sectionName && <span>
                                                {section.sectionName}
                                            </span>}
                                            {!section.sectionName && <span>
                                                description-dummy heading
                                            </span>}
                                        </span>
                                    </Nav.Link>
                                </div>                                
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <Button type="submit" varient="primary" onClick={this.onXMLDownload.bind(this,section._id)}>
                                                XML 
                                            </Button>
                                        </div>
                                        {this.state.isAdminUser && <div className="col-md-2">
                                            <Button type="submit" varient="primary" onClick={this.onAddCost.bind(this,section._id)}>
                                                Add cost   
                                            </Button>
                                        </div>
                                        }
                                        {this.state.isAdminUser && <div className="col-md-3">
                                            <Button type="submit" varient="primary" onClick={this.onSectionDelete.bind(this,this.props.reportId,section._id)}>
                                                Delete section
                                            </Button>
                                            </div>
                                        }
                                        {section.sectionName && this.state.isAdminUser && <div className="col-md-2">
                                            <Button type="submit" varient="primary" onClick={this.onSectionNameChange.bind(this,this.props.reportId,section._id)}>
                                                Change name
                                            </Button>    
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                <Modal size="lg" show={this.state.addCost} onHide={this.onHide} className="modal-size">
                    <Modal.Header closeButton>
                        <div className="row col-md-12">
                            <Modal.Title className="col-md-6 heading-details">Add Cost</Modal.Title>
                        </div>   
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <AddSectionCost sectionId={this.state.sectionId} sectionName={this.state.sectionName} onSave={this.onHide}/>
                    </Modal.Body>
                </Modal>
                <Modal size="lg" show={this.state.showChangeName} onHide={this.onSectionNameClose} className="modal-size">
                    <Modal.Header closeButton>
                        <div className="row col-md-12">
                            <Modal.Title className="col-md-6 heading-details">Change Name</Modal.Title>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <ChangeName sectionId={this.state.sectionId} reportId={this.props.reportId} onSave={this.onSectionNameClose}></ChangeName>
                    </Modal.Body>
                </Modal>
            </div>

        )
    }
}

const mapStateToProps = state => ({
    section:state
});

const mapDispatchToProps = dispatch => ({
    XMLDownload:(v) => dispatch(actions.XMLDownload(v)),
    onSectionDelete:(v) => dispatch(actions.onSectionDelete(v))
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Section));


// WEBPACK FOOTER //
// ./src/components/Section/section.jsx